export default __webpack_public_path__ + "static/media/Vest of the Bloodhunter.400778ab.jpg";